import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-[#111827]" data-id="element-91">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col md:flex-row items-center gap-8 bg-[#1a2332] border border-gray-800 rounded-2xl p-8" data-id="element-93">
          <div className="flex-shrink-0" data-id="element-94">
            <div className="w-24 h-24 bg-blue-500/10 rounded-full flex items-center justify-center border-2 border-blue-500" data-id="element-95">
              <ShieldCheck className="w-12 h-12 text-blue-500" data-id="element-96" />
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-97">
            <h3 className="text-2xl font-bold text-white mb-3" data-id="element-98">
              🛡️ GARANTÍA DE PAZ MENTAL (7 DÍAS)
            </h3>
            <p className="text-gray-300 mb-4 leading-relaxed" data-id="element-99">
              Probá el material. Si después de una semana no sentís que
              recuperaste horas de tu agenda y que tus consultas están más
              organizadas, te devolvemos el 100% de tu dinero.
            </p>
            <p className="text-yellow-500 font-bold" data-id="element-100">
              Sin preguntas. Sin vueltas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}